import { getTodayString } from "@/libraries/date";
import { createStore } from "zustand";
import { persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { useStoreWithEqualityFn } from "zustand/traditional";

interface HemiStoreState {
	lastShownPopup: ReturnType<typeof getTodayString> | null;
	isPopupOpen: boolean;
}

interface HemiStoreActions {
	shouldShowPopup: () => boolean;
	showPopup: () => void;
	markAsShown: () => void;
}

type HemiStore = HemiStoreState & HemiStoreActions;

export const useHemiStore = createStore<HemiStore>()(
	persist(
		(set, get) => ({
			lastShownPopup: null,
			isPopupOpen: false,
			shouldShowPopup: () => {
				const { lastShownPopup } = get();
				const today = getTodayString();
				return lastShownPopup !== today;
			},

			showPopup: () => {
				const { shouldShowPopup } = get();
				if (shouldShowPopup()) {
					set({ isPopupOpen: true });
				}
			},

			markAsShown: () => {
				const today = getTodayString();
				set({
					lastShownPopup: today,
					isPopupOpen: false,
				});
			},
		}),
		{
			name: "hemi",
			partialize: (state) => ({
				lastShownPopup: state.lastShownPopup,
			}),
		},
	),
);

export function useHemiShallow<T>(selector: (store: HemiStore) => T): T {
	return useStoreWithEqualityFn(useHemiStore, selector, shallow);
}
